import dayJs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { appConfig } from '@app/app';

dayJs.extend(utc);

// Streak DATE fields are stored as UTC midnight of the calendar day — a local-zone format shows the
// previous day anywhere west of UTC (the client is US Pacific).
export const formatCalendarDate = (value: string): string => dayJs.utc(value).format(appConfig.format.date);
